import { SVGProps } from "react";

export const FiveFriendsIcon = (props: SVGProps<SVGSVGElement>) => {
    return <svg width="86rem" height="91rem" viewBox="0 0 86 91" fill="none" {...props}>
        <rect x="44.5" y="15.5" width="39" height="39" rx="19.4789" fill="url(#paint0_radial_5946_68951)" stroke="url(#paint1_linear_5946_68951)" />
        <g filter="url(#filter0_d_5946_68951)">
            <circle cx="55.9707" cy="26.9707" r="3.05407" fill="white" />
            <circle cx="71.6123" cy="26.9707" r="3.05407" fill="white" />
        </g>
        <g filter="url(#filter1_d_5946_68951)">
            <path d="M62 30C62 31.1046 62.8954 32 64 32C65.1046 32 66 31.1046 66 30" stroke="white" strokeLinecap="round" />
        </g>
        <rect x="8.5" y="0.5" width="39" height="39" rx="19.4789" fill="url(#paint2_radial_5946_68951)" stroke="url(#paint3_linear_5946_68951)" />
        <g filter="url(#filter2_d_5946_68951)">
            <circle cx="19.9707" cy="11.9707" r="3.05407" fill="white" />
            <circle cx="35.6123" cy="11.9707" r="3.05407" fill="white" />
        </g>
        <g filter="url(#filter3_d_5946_68951)">
            <path d="M26 15C26 16.1046 26.8954 17 28 17C29.1046 17 30 16.1046 30 15" stroke="white" strokeLinecap="round" />
        </g>
        <rect x="25.5" y="26.5" width="39" height="39" rx="19.4789" fill="url(#paint4_radial_5946_68951)" stroke="url(#paint5_linear_5946_68951)" />
        <g filter="url(#filter4_d_5946_68951)">
            <circle cx="36.9707" cy="37.9707" r="3.05407" fill="white" />
            <circle cx="52.6123" cy="37.9707" r="3.05407" fill="white" />
        </g>
        <g filter="url(#filter5_d_5946_68951)">
            <path d="M43 41C43 42.1046 43.8954 43 45 43C46.1046 43 47 42.1046 47 41" stroke="white" strokeLinecap="round" />
        </g>
        <rect x="0.5" y="37.5" width="39" height="39" rx="19.4789" fill="url(#paint6_radial_5946_68951)" stroke="url(#paint7_linear_5946_68951)" />
        <g filter="url(#filter6_d_5946_68951)">
            <circle cx="11.9707" cy="48.9707" r="3.05407" fill="white" />
            <circle cx="27.6123" cy="48.9707" r="3.05407" fill="white" />
        </g>
        <g filter="url(#filter7_d_5946_68951)">
            <path d="M18 52C18 53.1046 18.8954 54 20 54C21.1046 54 22 53.1046 22 52" stroke="white" strokeLinecap="round" />
        </g>
        <rect x="46.5" y="51.5" width="39" height="39" rx="19.4789" fill="url(#paint8_radial_5946_68951)" stroke="url(#paint9_linear_5946_68951)" />
        <g filter="url(#filter8_d_5946_68951)">
            <circle cx="57.9707" cy="62.9707" r="3.05407" fill="white" />
            <circle cx="73.6123" cy="62.9707" r="3.05407" fill="white" />
        </g>
        <g filter="url(#filter9_d_5946_68951)">
            <path d="M64 66C64 67.1046 64.8954 68 66 68C67.1046 68 68 67.1046 68 66" stroke="white" strokeLinecap="round" />
        </g>
        <defs>
            <filter id="filter0_d_5946_68951" x="50.5606" y="21.5606" width="26.4618" height="10.8202" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5946_68951" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5946_68951" result="shape" />
            </filter>
            <filter id="filter1_d_5946_68951" x="59.144" y="27.144" width="9.712" height="7.712" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5946_68951" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5946_68951" result="shape" />
            </filter>
            <filter id="filter2_d_5946_68951" x="14.5606" y="6.56063" width="26.4618" height="10.8202" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5946_68951" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5946_68951" result="shape" />
            </filter>
            <filter id="filter3_d_5946_68951" x="23.144" y="12.144" width="9.712" height="7.712" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5946_68951" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5946_68951" result="shape" />
            </filter>
            <filter id="filter4_d_5946_68951" x="31.5606" y="32.5606" width="26.4618" height="10.8202" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5946_68951" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5946_68951" result="shape" />
            </filter>
            <filter id="filter5_d_5946_68951" x="40.144" y="38.144" width="9.712" height="7.712" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5946_68951" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5946_68951" result="shape" />
            </filter>
            <filter id="filter6_d_5946_68951" x="6.56063" y="43.5606" width="26.4618" height="10.8202" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5946_68951" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5946_68951" result="shape" />
            </filter>
            <filter id="filter7_d_5946_68951" x="15.144" y="49.144" width="9.712" height="7.712" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5946_68951" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5946_68951" result="shape" />
            </filter>
            <filter id="filter8_d_5946_68951" x="52.5606" y="57.5606" width="26.4618" height="10.8202" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5946_68951" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5946_68951" result="shape" />
            </filter>
            <filter id="filter9_d_5946_68951" x="61.144" y="63.144" width="9.712" height="7.712" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5946_68951" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5946_68951" result="shape" />
            </filter>
            <radialGradient id="paint0_radial_5946_68951" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(64 34) rotate(90) scale(20)">
                <stop stopColor="#D9D9D9" stopOpacity="0.68" />
                <stop offset="1" stopColor="#737373" stopOpacity="0" />
            </radialGradient>
            <linearGradient id="paint1_linear_5946_68951" x1="64" y1="16" x2="64" y2="54" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#999999" stopOpacity="0" />
            </linearGradient>
            <radialGradient id="paint2_radial_5946_68951" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(28 19) rotate(90) scale(20)">
                <stop stopColor="#D9D9D9" stopOpacity="0.68" />
                <stop offset="1" stopColor="#737373" stopOpacity="0" />
            </radialGradient>
            <linearGradient id="paint3_linear_5946_68951" x1="28" y1="1" x2="28" y2="39" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#999999" stopOpacity="0" />
            </linearGradient>
            <radialGradient id="paint4_radial_5946_68951" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(45 45) rotate(90) scale(20)">
                <stop stopColor="#D9D9D9" stopOpacity="0.68" />
                <stop offset="1" stopColor="#737373" stopOpacity="0" />
            </radialGradient>
            <linearGradient id="paint5_linear_5946_68951" x1="45" y1="27" x2="45" y2="65" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#999999" stopOpacity="0" />
            </linearGradient>
            <radialGradient id="paint6_radial_5946_68951" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(20 56) rotate(90) scale(20)">
                <stop stopColor="#D9D9D9" stopOpacity="0.68" />
                <stop offset="1" stopColor="#737373" stopOpacity="0" />
            </radialGradient>
            <linearGradient id="paint7_linear_5946_68951" x1="20" y1="38" x2="20" y2="76" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#999999" stopOpacity="0" />
            </linearGradient>
            <radialGradient id="paint8_radial_5946_68951" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(66 70) rotate(90) scale(20)">
                <stop stopColor="#D9D9D9" stopOpacity="0.68" />
                <stop offset="1" stopColor="#737373" stopOpacity="0" />
            </radialGradient>
            <linearGradient id="paint9_linear_5946_68951" x1="66" y1="52" x2="66" y2="90" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#999999" stopOpacity="0" />
            </linearGradient>
        </defs>
    </svg>

}